import React from "react";
import { withRouteData } from "react-static";

// Global Components
import Link from "components/link/link";

// Global Assets
import logo from "assets/images/logo.png";

// Local Components
import ProjectsNavigation from "./components/projectsNavigation/projectsNavigation";
import ProjectPreview from "./projectPreview";

// Local Assets
import "./projects.css";
import "./projects-mobile.css";

export default withRouteData(({ projects }) => (
  <div className="projects">
    <div className="logo-container">
      <Link to="/">
        <img style={{ maxWidth: "100%" }} src={logo} alt="Hecha Logo" />
      </Link>
    </div>
    <div className="contentContainer">
      <ProjectsNavigation projects={projects} />
      {projects.map(project => (
        <ProjectPreview project={project} />
      ))}
    </div>
  </div>
));
